import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

const Popular = props => {
  const items = props.filterPaths.map(item => (
    <Link
      onClick={e => {
        e.preventDefault();

        props.onChange({
          search: item.path,
          title: item.title,
        });
      }}
      title={item.title}
      key={item.title}
      to={props.location.pathname + item.path}
    >
      {item.title}
    </Link>
  ));
  return <span>{items}</span>;
};

const { func, arrayOf, shape, string } = PropTypes;

Popular.propTypes = {
  onChange: func.isRequired,
  filterPaths: arrayOf(
    shape({
      title: string.isRequired,
      path: string.isRequired,
    })
  ).isRequired,
  location: shape({
    pathname: string,
  }).isRequired,
};

export default Popular;
